<template>
    <v-modal :title="currentStepName" @close="closeModal" :size="size">
        <slot slot="content"/>
        <template slot="left-actions" v-if="canGoPreviousStep">
            <v-icon-button @click="goPreviousStep">
                <v-icon slot="left-icon" icon="arrow-left"/>
                {{backLabel}}
            </v-icon-button>
        </template>
        <template slot="actions" v-if="canGoNextStep">
            <v-icon-button v-if="!isLastStep" @click="goNextStep" class="btn-primary" >
                {{nextStepLabel}}
                <v-icon slot="right-icon" icon="arrow-right"/>
            </v-icon-button>
            <r-button v-else  @click="goNextStep" type="primary">
                {{nextStepLabel}}
            </r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {vIconButton, vIcon} from '@/components/form';
    import vFormWizard from './v-form-wizard';

    export default {
        name: 'v-form-wizard-modal',
        extends: vFormWizard,
        props: {
            size: String,
        },
        components: {
            vIcon,
            vIconButton,
            vModal,
        },
        methods: {
            closeModal() {
                this.$emit('close');
            },
        },
    };
</script>
